import { ClientContextResponse as ClientContext } from '@ancon/wildcat-types'

import { ClientContextCompanyUser } from '../types'
import isAppWhiteLabeled from '../../app/utils/isAppWhiteLabeled'
import getTenantIds from '../../app/utils/getTenantIds'

/**
 * Extracts company users from clientContext. Company ordering is
 * white-label only, so Ancon Order users order privately.
 */
export default function extractCompanyUsers(
  clientContext: ClientContext | null,
): ClientContextCompanyUser[] {
  const companyUsers = clientContext?.companyUsers

  if (!isAppWhiteLabeled()) {
    return []
  }

  if (companyUsers?.length) {
    return companyUsers.reduce<Array<ClientContextCompanyUser>>((acc, user) => {
      const { id, name, fullName, email, emailVerified, company } = user

      // Skip company users that don't belong to any app tenant
      if (!getTenantIds().includes(company.tenantId)) {
        return acc
      }

      acc.push({
        id,
        fullName,
        firstName: name.firstName,
        lastName: name.lastName,
        email,
        emailVerified,
        companyId: company.id,
        companyName: company.name,
        tenantId: company.tenantId,
        tenantName: company.tenantName,
        defaultInvoiceReferenceNote:
          company.defaultInvoiceReferenceNote ?? null,
        businessNumber: company.businessNumber || null,
        invoiceEmail: company.invoiceEmail || null,
        approvalStatus: company.status,
      })

      return acc
    }, [])
  }

  return []
}
